export default __webpack_public_path__ + "static/media/p38.9ddca54a.jpg";